import http from 'utils/http';
import {
  getTelephonyProvidersUrl,
  getTelephonyProviderUrl,
  getTelephonyProviderBusinessesUrl,
  manualSyncTelephonyProviderUrl,
  getTelephonyProviderSyncLogsUrl,
  updateTelephonyProviderMappingUrl
} from './apiUrls';
import {
  TelephonyProviderResponse,
  TelephonyProviderBusinessesParams,
  TelephonyProviderBusinessesResponse
} from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getTelephonyProviders(params: any): Promise<{
  data: TelephonyProviderResponse[];
  meta: MetaApiResponse;
}> {
  return http.get(getTelephonyProvidersUrl(), params);
}

export function getTelephonyProvider(id: string | number, params?: any): Promise<TelephonyProviderResponse> {
  return http.get(getTelephonyProviderUrl(id), params);
}

export function updateTelephonyProvider(
  id: string | number,
  payload: FormData | Record<string, any>
): Promise<TelephonyProviderResponse> {
  const data = payload instanceof FormData ? payload : { telephony_provider: payload };
  return http.put(getTelephonyProviderUrl(id), data);
}

export function getTelephonyProviderBusinesses(
  id: string | number,
  params?: TelephonyProviderBusinessesParams
): Promise<TelephonyProviderBusinessesResponse> {
  const query: Record<string, unknown> = {};

  if (params?.page != null) query.page = params.page;
  if (params?.per_page != null) query.per_page = params.per_page;

  const nameCont = params?.filter?.name_cont?.trim();
  if (nameCont) {
    query.filter = { name_cont: nameCont };
  }

  return http.get(getTelephonyProviderBusinessesUrl(id), query);
}

export function manualSyncTelephonyProvider(
  id: string | number,
  payload: { telephony_provider: { business_id: number }; sync_type: string }
): Promise<{ message: string }> {
  return http.post(manualSyncTelephonyProviderUrl(id), payload);
}

export function getTelephonyProviderSyncLogs(id: string | number, businessId?: number): Promise<any> {
  return http.get(getTelephonyProviderSyncLogsUrl(id, businessId));
}

export function updateTelephonyProviderMapping(
  id: string | number,
  payload: { telephony_provider: { business_id: number; frequency: string } }
): Promise<{ message: string }> {
  return http.patch(updateTelephonyProviderMappingUrl(id), payload);
}
